import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable no-param-reassign */
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import { ChevronLeftIcon, ChevronRightIcon } from '@beef/ui-kit';
import { DeviceContainer } from "../../DeviceContainer";
import { useGetDimensionGroup } from "../../../hooks/useGetDimensionGroup";
import { getChildrenLength } from "../../../utils/getChildrenLength";
import { Carousel } from "../../Carousel";
import { useGetSlidesPerGroup, useGetSlidesPerView } from "../hooks";
import style from "../styles.module.pcss";
var cn = classNames.bind(style);
var RecommendationProductsList = function RecommendationProductsList(_ref) {
  var status = _ref.status,
    _ref$skeletonItemsCou = _ref.skeletonItemsCount,
    skeletonItemsCount = _ref$skeletonItemsCou === void 0 ? 0 : _ref$skeletonItemsCou,
    showSliderArrow = _ref.showSliderArrow,
    maxSlides = _ref.maxSlides,
    children = _ref.children,
    _onInit = _ref.onInit,
    noPadding = _ref.noPadding,
    _ref$sliderSettings = _ref.sliderSettings,
    sliderSettings = _ref$sliderSettings === void 0 ? {} : _ref$sliderSettings,
    sendYm = _ref.sendYm;
  var dimension = useGetDimensionGroup();
  var carouselRef = useRef(null);
  var slidesPerView = useGetSlidesPerView(dimension, carouselRef, maxSlides);
  var slidesPerGroup = useGetSlidesPerGroup(dimension);
  var prevRef = useRef(null);
  var nextRef = useRef(null);
  var swiperRef = useRef(null);
  var childrenCount = getChildrenLength(children);
  useEffect(function () {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      var navigationParams = swiperRef.current.params.navigation;
      navigationParams.prevEl = prevRef.current;
      navigationParams.nextEl = nextRef.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, [prevRef.current, nextRef.current, swiperRef]);
  var settings = _objectSpread({
    keyboard: {
      enable: true,
      onlyInViewport: true,
      pageUpDown: true
    },
    slidesPerView: slidesPerView,
    onInit: function onInit(swiper) {
      swiperRef.current = swiper;
      if (_onInit) {
        _onInit(swiper);
      }
    },
    pagination: {
      renderBullet: function renderBullet(index, className) {
        return "<span class=\"".concat(cn(className, 'pagination'), "\"></span>");
      },
      clickable: true
    },
    spaceBetween: 16,
    loop: false,
    slidesPerGroup: slidesPerGroup
  }, sliderSettings);
  if (status === 'loading') {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      React.createElement(DeviceContainer, {
        className: cn('device-container-loading'),
        contentMaxWidth: 167,
        isFetching: true,
        previewCardsLength: skeletonItemsCount
      })
    );
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn('carousel-wrap')
  }, childrenCount > 4 && !showSliderArrow && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: cn('next-nav', 'nav'),
    ref: nextRef,
    type: "button"
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, null)), /*#__PURE__*/React.createElement("button", {
    className: cn('prev-nav', 'nav'),
    ref: prevRef,
    type: "button"
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, null))), /*#__PURE__*/React.createElement("div", {
    ref: carouselRef
  }, /*#__PURE__*/React.createElement(Carousel, {
    className: cn('swiper-recommend', {
      'no-padding': noPadding
    }),
    paginatePadding: true,
    sendYm: sendYm,
    settings: settings
  }, children)));
};
export default RecommendationProductsList;